import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ReactMarkdown from "react-markdown";
import "./blogdetails.css";

const BlogDetail = () => {
    const { slug } = useParams();
    const [content, setContent] = useState("");
    const [meta, setMeta] = useState({});

    console.log(meta);
    useEffect(() => {
        fetch(`/content/${slug}.md`)
            .then((res) => {
                if (!res.ok) throw new Error("File not found");
                return res.text();
            })
            .then((text) => {
                // 🔥 Manual frontmatter parsing
                const parts = text.split("---");

                if (parts.length > 2) {
                    const rawMeta = parts[1];
                    const markdownContent = parts.slice(2).join("---");

                    const metaObj = {};

                    rawMeta.split("\n").forEach((line) => {
                        const [key, ...valueParts] = line.split(":");
                        if (key && valueParts.length) {
                            metaObj[key.trim()] = valueParts
                                .join(":")
                                .trim()
                                .replace(/^"(.*)"$/, "$1");
                        }
                    });

                    setMeta(metaObj);
                    setContent(markdownContent);
                } else {
                    setContent(text);
                }
            })
            .catch((err) => console.error(err));
    }, [slug]);

    return (
        <div className="blog-detail">
            <div className="blog-container">
                <ReactMarkdown>{content}</ReactMarkdown>
            </div>
        </div>
    );
};

export default BlogDetail;